/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState, useEffect } from "react";
import { Box, Button, Divider, Grid, Stack, Tooltip } from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";

import Typography from "@mui/material/Typography";

import { Effect, ExpandedWorkOrder, FullAssignedTechnicianEntry } from "../../../utils/Interfaces";
import { updateTechEntries } from "../workOrderFunctions";
import CreateTechnicianEntryModal from "../CreateTechnicianEntryModal";
import OfficeTechnicianEntry from "./OfficeTechnicianEntry";
import { useAppDispatch } from "../../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export interface TechEntryGroupProps {
    workOrder: ExpandedWorkOrder;
}

const TechnicianEntryGroup = (props: TechEntryGroupProps) => {
    const { workOrder } = props;

    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    const [techEntries, setTechEntries] = useState<FullAssignedTechnicianEntry[]>();
    const [newFormModalOpen, setNewFormModalOpen] = useState<boolean>(false);

    useEffect(() => {
        updateTechEntries(workOrder.id, dispatch, setTechEntries, () => {});
    }, [dispatch]);

    let numTechEntries = 0;

    if (techEntries !== undefined && techEntries !== null) {
        numTechEntries = techEntries.length;
    }

    return (
        <Box>
            <Typography sx={{ fontSize: 30, mb: 1.5, mt: 2.5 }} color="text.primary">
                {`Technician Forms (${numTechEntries})`}
            </Typography>
            {techEntries !== undefined &&
                techEntries !== null &&
                techEntries.length > 0 &&
                techEntries.map((entry, key) => {
                    return (
                        <Box key={key}>
                            <OfficeTechnicianEntry
                                workOrder={workOrder}
                                techEntry={entry}
                                tripNumber={key + 1}
                                onTechnicianEntryModified={(additionalEffect?: Effect) => {
                                    updateTechEntries(
                                        workOrder.id,
                                        dispatch,
                                        (techEntries: FullAssignedTechnicianEntry[]) => {
                                            setTechEntries(techEntries);
                                            if (additionalEffect) {
                                                additionalEffect();
                                            }
                                        },
                                        () => {}
                                    );
                                }}
                            />
                        </Box>
                    );
                })}
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Tooltip title="Create New Technician Form/Trip">
                    <Button variant="contained" onClick={() => setNewFormModalOpen(true)} sx={{ mb: 2, ml: 1 }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Stack direction="column" justifyContent="center">
                                <PostAddIcon />
                            </Stack>
                            <Stack direction="column" justifyContent="center" sx={{ ml: 1 }}>
                                <Typography sx={{ mt: 0.25 }}>Create Trip</Typography>
                            </Stack>
                        </Stack>
                    </Button>
                </Tooltip>
            </Grid>

            <Divider />
            <CreateTechnicianEntryModal
                open={newFormModalOpen}
                handleClose={() => setNewFormModalOpen(false)}
                workOrder={workOrder}
                onSubmit={() => updateTechEntries(workOrder.id, dispatch, setTechEntries, () => {})}
            />
        </Box>
    );
};

export default TechnicianEntryGroup;
